export const backendURL = 'https://theraderm2-backend.onrender.com'